import { useTranslation } from "react-i18next";

export default function StickyMapButton() {
  const { t } = useTranslation();

  const handleClick = () => {
    window.open(
      "https://www.google.com/maps/search/Bursa+turistik+yerler/@40.1827,29.0669,13z",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 px-4 py-3 bg-forest-600 hover:bg-forest-500 text-white rounded-2xl transition-all cursor-pointer group"
      title={t("sticky_label")}
    >
      <div className="w-5 h-5 flex items-center justify-center">
        <i className="ri-map-pin-2-fill text-base text-white" />
      </div>
      <span className="text-xs font-semibold font-body whitespace-nowrap hidden sm:block">
        {t("sticky_label")}
      </span>
    </button>
  );
}
